import AdminApi from '../../services/api';
import swal from 'sweetalert2';
import session from '../../services/session';
import CONFIG_COMPANY from '../../services/myConfig';
import Loc from '../../services/localization';

const AdminApiService = new AdminApi();
const LocService = new Loc();

export default {
  data() {
    return {
      locale: LocService,
      role: '',
      loading: false,
      saving: false,
      filter: '',
      items: []
    };
  },
  computed: {
    filteredItems() {
      const query = (this.filter || '').toLowerCase().trim();
      if (!query) return this.items;
      return this.items.filter((item) => this.getDisplayName(item).toLowerCase().indexOf(query) !== -1);
    },
    payloadCount() {
      return this.getPayloadItems().length;
    }
  },
  methods: {
    loadItems: loadItems,
    saveInventory: saveInventory,
    getDisplayName: getDisplayName,
    normalizeImage: normalizeImage,
    getPayloadItems: getPayloadItems,
    isInvalidQuantity: isInvalidQuantity,
    toInventoryHistory: toInventoryHistory,
    keymonitor: keymonitor
  },
  beforeMount() {
    if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
      this.$router.push(CONFIG_COMPANY.HOME);
      return;
    }
    this.role = session.getRole();
    this.loadItems();
  }
};

function loadItems() {
  this.loading = true;
  AdminApiService.getCompanyInfoShopItems()
    .then((response) => {
      const data = response.data || [];
      this.items = data.map((item) => {
        const current = Number(item.stockNumber || 0);
        return Object.assign({}, item, {
          inventoryQuantity: String(current),
          initialInventoryQuantity: current
        });
      });
      this.loading = false;
    })
    .catch((error) => {
      this.loading = false;
      swal(LocService.t('label_error'), (error && error.data && error.data.localized_error_message) || LocService.t('label_no_data'), 'error');
    });
}

function isInvalidQuantity(value) {
  if (value == null || String(value).trim() === '') return true;
  if (!/^\d+$/.test(String(value).trim())) return true;
  return Number(value) < 0;
}

function getPayloadItems() {
  return this.items
    .filter((item) => item != null && item.id != null)
    .map((item) => {
      const raw = String(item.inventoryQuantity == null ? '' : item.inventoryQuantity).trim();
      if (raw === '') return null;
      if (!/^\d+$/.test(raw)) return null;
      const quantity = Number(raw);
      if (quantity < 0) return null;
      return {
        companyInfoId: item.id,
        quantity: quantity
      };
    })
    .filter((item) => item != null);
}

function saveInventory() {
  const hasInvalid = this.items.some((item) => this.isInvalidQuantity(item.inventoryQuantity));
  if (hasInvalid) {
    swal(LocService.t('label_error'), LocService.t('label_inventory_invalid_quantity'), 'error');
    return;
  }

  const payloadItems = this.getPayloadItems();
  if (payloadItems.length === 0) {
    swal(LocService.t('label_error'), LocService.t('label_inventory_no_changes'), 'warning');
    return;
  }

  swal({
    title: LocService.t('label_are_you_sure'),
    text: LocService.t('label_confirm_inventory'),
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#7c4dff',
    cancelButtonColor: '#8a94a6',
    confirmButtonText: LocService.t('label_yes'),
    cancelButtonText: LocService.t('label_no')
  }).then((result) => {
    const confirmed = result === true || (result && result.value === true);
    if (!confirmed) return;

    this.saving = true;
    AdminApiService.saveShopInventoryItems({ items: payloadItems })
      .then(() => {
        this.saving = false;
        swal(LocService.t('label_success'), LocService.t('label_inventory_saved'), 'success');
        this.loadItems();
      })
      .catch((error) => {
        this.saving = false;
        swal(LocService.t('label_error'), (error && error.data && error.data.localized_error_message) || LocService.t('label_all_field_required'), 'error');
      });
  });
}

function getDisplayName(item) {
  if (session.getLocale() === LocService.getDefaultLanguage()) {
    return item.name || '';
  }
  if (item.enName != null && item.enName.length > 0) {
    return item.enName;
  }
  return item.name || '';
}

function normalizeImage(item) {
  return item.imageMain || item.imageUrl || '';
}

function toInventoryHistory() {
  this.$router.push('/inventory-history');
}

function keymonitor(event) {
  if (event.key === 'Enter') {
    this.saveInventory();
  }
}



// WEBPACK FOOTER //
// ./src/components/Inventory/AddNewInventory.js